// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__NWL94","select":"Header_select__26hOD","clinic":"Header_clinic__xNcCy"};